/* eslint-disable */
import { Authority } from '@azure/msal-common';
import { css } from '@emotion/react';
import useTheme from '../../hooks/useTheme';
export default () => {
  const { breakpoints, colors, screenSizes, borderRadius, fluidTypeScale } =
    useTheme();
  return {
    cards: css`
      ${breakpoints.l} {
        :nth-of-type(2) {
          margin-top: 3.5rem;
        }
      }
    `,

    innerWrapper: css`
      padding-bottom: 1.5rem;
    `,

    card: css`
      grid-auto-rows: 8.3rem;
    `,

    header: (hasVideo) => css`
      text-transform: uppercase;
      font-size: ${fluidTypeScale.font11_12};
      color: ${colors.lightBlue};
      cursor: ${hasVideo ? 'pointer' : 'default'};
      letter-spacing: 0.12em;
      line-height: 16px;
      margin-bottom: 10px;

      ${breakpoints.m} {
        font-size: ${fluidTypeScale.font12_11};
        text-align: left;
        letter-spacing: 0.08em;
        line-height: 16px;
        font-weight: 700;
      }
    `,

    description: (hasVideo) => css`
      color: ${colors.lightGrey};
      font-size: ${fluidTypeScale.font20_20};
      cursor: ${hasVideo ? 'pointer' : 'default'};
      letter-spacing: 0.003em;
      height: auto;

      ${breakpoints.l} {
        font-size: ${fluidTypeScale.font20_20};
        font-weight: 400;
        line-height: 28px;
        text-align: left;
      }
    `,

    infoSection: css`
      ${breakpoints.l} {
        min-width: 15.625rem;
      }
    `,

    learnMore: css`
      display: flex;
      align-items: center;
      Padding: 8px 0px 8px 0px;
      color:${colors.lightGrey};
      border-top:1px solid ${colors.darkGrey};
      margin-top:20px;

      ${breakpoints.l} {
      border-top:1px solid ${colors.darkGrey};
      display: flex;
      margin-top:20px;
      `,

    imgSection: ({ desktop, mobile }, indexVal, hasVideo) => css`
      width: 100%;
      height: 195px;
      background: url(${mobile.src}) 0 0 no-repeat;
      background-size: cover;
      position: relative;
      margin-top: 19px;
      cursor: ${hasVideo ? 'pointer' : 'default'};
      margin-left: 1px !important;

      ${breakpoints.l} {
        width: 100%;
      }
      @media (min-width: 420px) and (max-width: 768px) {
        background-size: 115% 165%;
      }

      .youtube {
        cursor: pointer;
        position: absolute;
        bottom: 40%;
        z-index: 2;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        &:hover {
          filter: brightness(77%);
        }
      }

      &:focus-visible {
        outline: none;
        .youtube {
          border: 2px solid  ${colors.border_black};
          outline: 2px solid ${colors.skip_yellow};
        }
      }
    `,

    cardalign: css`
      background-color: ${colors.navy};
      padding: 32px 32px 16px 32px;
      color: ${colors.lightGrey};
    `,

    learnmore: css`
      font-size: ${fluidTypeScale.font15_16};
      letter-spacing: 0.12em;
      text-align: left;
      color: ${colors.white};
      text-transform: uppercase;
      font-weight: 700;
    `,

    learnmoreArrow: css`
      margin-left: 1rem;
    `,

    link: css`
      text-decoration: none;
      &:hover {
        text-decoration: underline;
        text-decoration-color: ${colors.white};
      }
      &:focus-visible {
        background-color: ${colors.skip_yellow};
        outline: none;
        border-bottom: 2px solid ${colors.border_black};
        &:hover{
          text-decoration: underline;
          text-decoration-color: ${colors.black};
        }
        p span {
          color: ${colors.black};
        }
        p img {
          filter: grayscale(1) brightness(0) invert(0);
        }
      }
    `,
  };
};
